var map = {
	"./account.svg": 97112,
	"./advanced.svg": 78308,
	"./alarm.svg": 90564,
	"./badge-basic.svg": 16292,
	"./badge-community.svg": 33936,
	"./badge-membership.svg": 45116,
	"./badge-participation.svg": 11948,
	"./badge-role.svg": 38184,
	"./badge-ticket.svg": 58652,
	"./bell-notification.svg": 24952,
	"./bell-ring.svg": 31840,
	"./calendar-check.svg": 19532,
	"./calendar-days.svg": 58173,
	"./calendar-duration.svg": 88204,
	"./calendar-event.svg": 50544,
	"./calendar.svg": 896,
	"./checkbox-fill.svg": 33452,
	"./checklist.svg": 19564,
	"./chevron-down.svg": 86868,
	"./chevron-left.svg": 57791,
	"./clock-check.svg": 72128,
	"./clock.svg": 91560,
	"./cloud-off.svg": 8404,
	"./color.svg": 87704,
	"./copy.svg": 77952,
	"./cross.svg": 82540,
	"./cube.svg": 98664,
	"./cup.svg": 86284,
	"./dashboard.svg": 26320,
	"./delete-solid.svg": 79700,
	"./download.svg": 29520,
	"./edit-pencil.svg": 95980,
	"./edit-solid.svg": 844,
	"./emoji_activities.svg": 79672,
	"./emoji_animals_nature.svg": 13784,
	"./emoji_flags.svg": 19948,
	"./emoji_food_drink.svg": 49356,
	"./emoji_objects.svg": 22848,
	"./emoji_smileys_people.svg": 10820,
	"./emoji_symbols.svg": 16948,
	"./emoji_travel_places.svg": 8652,
	"./file-solid.svg": 5728,
	"./file-upload.svg": 68136,
	"./flag.svg": 42428,
	"./globe.svg": 88160,
	"./help.svg": 66148,
	"./image.svg": 82732,
	"./infinity.svg": 74220,
	"./info.svg": 92384,
	"./key.svg": 73276,
	"./layer.svg": 70364,
	"./layers.svg": 16364,
	"./link-break.svg": 46852,
	"./link.svg": 42920,
	"./location.svg": 84480,
	"./log-out.svg": 10704,
	"./magnifying-glass.svg": 68756,
	"./mail.svg": 80060,
	"./map-pin.svg": 63516,
	"./map.svg": 356,
	"./more-vertical.svg": 92284,
	"./note-edit.svg": 36220,
	"./notebook.svg": 42804,
	"./ongoing.svg": 82416,
	"./paper-plane.svg": 32072,
	"./path.svg": 17500,
	"./plus.svg": 25992,
	"./qr-code.svg": 56048,
	"./question-circle.svg": 57964,
	"./radio-fill.svg": 58876,
	"./rotate.svg": 11556,
	"./save.svg": 10216,
	"./scan.svg": 68892,
	"./select-multiple.svg": 97936,
	"./send-solid.svg": 99884,
	"./settings.svg": 15813,
	"./shape_1.svg": 65272,
	"./shape_2.svg": 92528,
	"./shape_3.svg": 26860,
	"./shape_4.svg": 88484,
	"./shape_5.svg": 18732,
	"./shape_6.svg": 17052,
	"./show.svg": 81460,
	"./smiley.svg": 4108,
	"./text-align-left.svg": 31020,
	"./trash-empty.svg": 17215,
	"./trash.svg": 73732,
	"./triangle-left.svg": 27424,
	"./triangle-right.svg": 26872,
	"./unfold-more.svg": 25524,
	"./user-add.svg": 76367,
	"./user-square.svg": 78620,
	"./wavy-check.svg": 89428
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41760;